import { UseAuthModalsResult } from '../../hooks/auth/useAuthModals';
import VerificationModal from './verificationModal';
import InviteOnlyModal from './inviteOnlyModal';
import ForgotPasswordModal from './forgotPasswordModal';
import { FailedNotification } from './failedNotification';

const COGNITO_CLIENT_ID = process.env.REACT_APP_CLIENT_ID ?? '';
const COGNITO_REGION = 'eu-central-1';

interface AuthModalsGroupProps {
  modals: UseAuthModalsResult;
  email: string;
  onLoginAfterVerification: () => Promise<void>;
  onForgotPasswordSuccess?: () => void;
}

/**
 * Groups all authentication-related modals together.
 */
export const AuthModalsGroup = ({
  modals,
  email,
  onLoginAfterVerification,
  onForgotPasswordSuccess,
}: AuthModalsGroupProps) => {
  return (
    <>
      <FailedNotification
        show={modals.failureNotification.isOpen}
        setShow={(show) => (show ? null : modals.failureNotification.close())}
        title="Login failed"
        body={modals.failureNotification.message || 'Wrong username or password'}
      />

      <InviteOnlyModal
        open={modals.inviteOnly.isOpen}
        setOpen={(open) => (open ? modals.inviteOnly.open() : modals.inviteOnly.close())}
      />

      {modals.verification.isOpen && (
        <VerificationModal
          clientId={COGNITO_CLIENT_ID}
          region={COGNITO_REGION}
          email={email}
          loginFunc={onLoginAfterVerification}
        />
      )}

      <ForgotPasswordModal
        isOpen={modals.forgotPassword.isOpen}
        onClose={modals.forgotPassword.close}
        onSuccess={() => {
          onForgotPasswordSuccess?.();
        }}
      />
    </>
  );
};
